module.exports = __webpack_public_path__ + "static/img/2_2_3.b6370d77.jpg";